export const ActionTypes = {
    GET_ISSUES: "GET_ISSUES",
    SET_EDIT_ISSUE: "SET_EDIT_ISSUE",
    RESTORE_INITIAL: "RESTORE_INITIAL",
    SET_ISSUES_FILTERS: "SET_ISSUES_FILTERS",
    NEW_ISSUE: "NEW_ISSUE",
    SET_ASSIGN_ISSUE: "SET_ASSIGN_ISSUE",
    UPDATE_ISSUE: "UPDATE_ISSUE"
};
